export const safariExperiences = [
    {
        slug: '17-days-ultimate-safari',
        title: '17 Days Ultimate Uganda Safari',
        duration: '17 Days',
        description: 'The most comprehensive Uganda safari experience covering all major national parks, primates, and cultural encounters.',
        image: '/images/packages/17-days-safari.jpg',
        link: '/packages/17-days-ultimate-safari',
        highlights: ['Gorilla Trekking', 'Chimpanzee Tracking', 'Tree-Climbing Lions', 'Murchison Falls', 'Cultural Encounters']
    },
    {
        slug: '12-days-wildlife-safari',
        title: '12 Days Uganda Wildlife Safari Tour',
        duration: '12 Days',
        description: 'Perfect balance of primate encounters and classic Big Five game viewing across four spectacular national parks.',
        image: '/images/packages/12-days-safari.jpg',
        link: '/packages/12-days-wildlife-safari',
        highlights: ['Mountain Gorillas', 'Chimpanzees', 'Murchison Falls', 'Kazinga Channel', 'Walking Safari']
    },
    {
        slug: '10-days-birding-safari',
        title: '10 Days Uganda Birding Safari',
        duration: '10 Days',
        description: 'Specialist birding safari through Uganda\'s Western Loop targeting 300+ species including rare Albertine endemics.',
        image: '/images/packages/10-days-birding.jpg',
        link: '/packages/10-days-birding-safari',
        highlights: ['Shoebill Stork', 'Albertine Endemics', 'Mabamba Wetland', 'Bwindi Forest', '600+ Bird Species']
    },
    {
        slug: '8-days-highlights-safari',
        title: '8 Days Uganda Safari Highlights',
        duration: '8 Days',
        description: 'Ultimate introduction to Uganda\'s biodiversity combining four iconic national parks in one epic journey.',
        image: '/images/packages/8-days-highlights.jpg',
        link: '/packages/8-days-highlights-safari',
        highlights: ['Gorilla Trekking', 'Chimp Tracking', 'Tree-Climbing Lions', 'Rhino Tracking', 'Boat Safaris']
    },
    {
        slug: '7-days-gorilla-chimp-safari',
        title: '7 Days Gorilla & Chimpanzee Safari',
        duration: '7 Days',
        description: 'Focused primate safari with deep, meaningful connections to our closest evolutionary relatives.',
        image: '/images/packages/7-days-gorilla-chimp.jpg',
        link: '/packages/7-days-gorilla-chimp-safari',
        highlights: ['Mountain Gorillas', 'Chimpanzees', 'Tree-Climbing Lions', 'Kazinga Channel', 'Batwa Culture']
    },
    {
        slug: '5-days-gorillas-lions',
        title: '5 Day Gorillas and Lions Tour',
        duration: '5 Days',
        description: 'Compact yet powerful safari combining iconic gorilla trekking with classic savannah wildlife viewing.',
        image: '/images/packages/5-days-gorillas-lions.jpg',
        link: '/packages/5-days-gorillas-lions',
        highlights: ['Gorilla Trekking', 'Tree-Climbing Lions', 'Kazinga Channel', 'Game Drives', 'Quick Getaway']
    },
    {
        slug: '3-days-kibale-chimp-cultural',
        title: '3 Days Chimpanzee & Cultural Safari - Kibale',
        duration: '3 Days',
        description: 'Perfect weekend escape combining chimpanzee trekking with cultural immersion in the Primate Capital.',
        image: '/images/packages/3-days-kibale-cultural.jpg',
        link: '/packages/3-days-kibale-chimp-cultural',
        highlights: ['Chimp Trekking', 'Bigodi Wetland', 'Cultural Village', 'Crater Lakes', '90-95% Success Rate']
    },
    {
        slug: '3-days-murchison-chimp',
        title: '4 Days Murchison Falls & Chimpanzee Tracking',
        duration: '4 Days',
        description: 'Experience the world\'s most powerful waterfall combined with chimpanzee tracking in Budongo Forest.',
        image: '/images/packages/4-days-murchison-chimp.jpg',
        link: '/packages/3-days-murchison-chimp',
        highlights: ['Murchison Falls', 'Chimp Tracking', 'Nile Boat Cruise', 'Game Drives', 'Top of Falls Hike']
    },
    {
        slug: 'queen-elizabeth-safari',
        title: '3 Days Safari to Queen Elizabeth National Park',
        duration: '3 Days',
        description: 'Uganda\'s most biodiverse park featuring tree-climbing lions and the highest hippo concentration in Africa.',
        image: '/images/packages/3-days-queen-elizabeth.jpg',
        link: '/packages/queen-elizabeth-safari',
        highlights: ['Tree-Climbing Lions', 'Kazinga Channel', 'Game Drives', 'Crater Lakes', '95 Mammal Species']
    }
]
